/**
 * backgrounds.js — territory colouring for the arena.
 *
 * This used to also own four flat per-screen cityscapes. Those are gone: the
 * backdrop is a parallax stack now (see parallax.js), which is one set of art
 * for all seven screens and adapts to any frame shape, where a photograph can
 * only be stretched. What is left is the part that was never about the
 * photographs — the wash that tells you whose ground you are fighting on.
 */

/**
 * Wash the canvas with the current screen's territory colour: transparent at
 * the contested middle, deepening red toward Red's goal (screen 0) and green
 * toward Green's goal (screen 6).
 *
 * Painted as a horizontal gradient anchored on the owning player's edge rather
 * than a flat fill — a flat wash at the outer screens was strong enough to
 * flatten the artwork into a monochrome haze, while a gradient reads as light
 * spilling from the goal and leaves the middle of the frame legible.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} screen Current screen index (0..6).
 */
export function paintTerritoryTint(ctx, screen) {
  const offset = screen - 3; // -3 (deep red territory) .. +3 (deep green)
  if (offset === 0) return;

  const alpha = 0.07 * Math.abs(offset); // 0.07 / 0.14 / 0.21 at the edge
  const rgb = offset < 0 ? '255, 71, 87' : '0, 255, 65';
  const width = ctx.canvas.width;

  // Red owns the left edge, Green the right: run the gradient inward from
  // whichever edge the goal sits on.
  const fromLeft = offset < 0;
  const gradient = ctx.createLinearGradient(fromLeft ? 0 : width, 0, fromLeft ? width : 0, 0);
  gradient.addColorStop(0, `rgba(${rgb}, ${alpha})`);
  gradient.addColorStop(1, `rgba(${rgb}, 0)`);

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, width, ctx.canvas.height);
}
